var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-item',{attrs:{"link":{name: _vm.$t('Персоны'), icon: 'nc-icon nc-circle-09'}}},[_c('sidebar-item',{attrs:{"link":{name:  _vm.$t('Персоны'), path: `/person`}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }